/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type ThemeMode = (typeof ThemeMode)[keyof typeof ThemeMode]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ThemeMode = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
} as const
